import { z } from 'zod';

export const CitationSchema = z.object({
  url: z.string(),
  title: z.string().nullable().optional(),
});

export const ParametersSchema = z.object({
  hue_shift: z.number().min(0).max(360),
  mosh_intensity: z.number().min(0).max(1),
  scanline_density: z.number().min(0).max(1),
  beat_bpm: z.number().int().min(60).max(180),
  agitation: z.number().min(0).max(1),
  palette: z.array(z.string()).length(3),
  signal_ticker: z.array(z.string()).max(6),
  enemies: z.array(z.string()).min(3).max(10),
  sources: z.array(CitationSchema).max(8),
  cycle: z.number().int().nonnegative(),
  generated_at: z.string(),
});

export type Citation = z.infer<typeof CitationSchema>;
export type Parameters = z.infer<typeof ParametersSchema>;

export const FALLBACK_PARAMETERS: Parameters = {
  hue_shift: 285,
  mosh_intensity: 0.5,
  scanline_density: 0.4,
  beat_bpm: 90,
  agitation: 0.4,
  palette: ['#ff00aa', '#00ffe0', '#1a0036'],
  signal_ticker: [
    'hrmntr // offline mode',
    'cycle: pending',
    'sources: cached',
    'oslo says hello anyway',
  ],
  enemies: ['MARKET GHOST', 'CABINET NOISE', 'FAULTLINE', 'WIND DIRECTIVE'],
  sources: [],
  cycle: 0,
  generated_at: new Date(0).toISOString(),
};
